<template>
  <div>
    <div class="table_box">
      <el-table :data="progressData">
        <el-table-column prop="rowTitle" label="" align="center" min-width="130"> </el-table-column>
        <el-table-column
          v-for="week in weeks"
          :key="week"
          :label="$t(`promotion.fundsGrowthPromotion.rewardSummary.table.week${week}`)"
          min-width="150"
        >
          <template slot-scope="scope">
            <div v-if="scope.row[week]">
              <i :class="['el-icon-success', 'text-base', { active: true }]"></i>
              <span class="text-blueG0">
                ${{
                  scope.row[week].amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                }}
              </span>
            </div>
            <div v-else class="secondaryText">--</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="totalRewardAmount"
          :label="$t('promotion.fundsGrowthPromotion.rewardSummary.totalRewardAmount')"
          align="center"
          min-width="150"
        >
          <template slot-scope="scope">
            <div :class="tradesAchieved ? 'text-blueG0' : 'text_error'">
              <i
                :class="['text-base', { 'el-icon-error': !tradesAchieved, 'el-icon-success active': tradesAchieved }]"
              ></i>
              {{
                scope.row.totalRewardAmount.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="ltr:text-left rtl:text-right mt-6 mb-4">
      <div class="mb-2">{{ $t('promotion.fundsGrowthPromotion.rewardSummary.tableFooter') }}</div>
      <ul class="mb-6 ltr:ml-6 rtl:mr-6">
        <li>{{ $t('promotion.fundsGrowthPromotion.rewardSummary.tableFooterCondition1') }}</li>
        <li>{{ $t('promotion.fundsGrowthPromotion.rewardSummary.tableFooterCondition2') }}</li>
        <li>{{ $t('promotion.fundsGrowthPromotion.rewardSummary.tableFooterCondition3') }}</li>
      </ul>
      <i18n path="promotion.fundsGrowthPromotion.rewardSummary.referTnc" tag="div">
        <template v-slot:tnc>
          <a :href="tncLink" target="_blank">{{ $t('promotion.fundsGrowthPromotion.tnc') }}</a>
        </template>
      </i18n>
    </div>
  </div>
</template>

<script>
import { startLoading, endLoading } from '@/util/loading';
import { apiGetFgpMonthlyHistory } from '@/resource';
export default {
  name: 'RewardSummary',
  props: {
    campaignId: Number,
    selectedAccount: Number,
    tncLink: String
  },
  data() {
    return {
      weeks: ['1', '2', '3', '4'],
      progressData: [],
      activeAccounts: [],
      totalRewardAmount: undefined,
      tradesAchieved: false
    };
  },
  async mounted() {
    await this.getFgpMonthlyHistory();
    if (this.selectedAccount) this.getWeeklyProgress();
  },
  watch: {
    selectedAccount() {
      startLoading();
      this.getWeeklyProgress();
      endLoading();
    }
  },
  methods: {
    getWeeklyProgress() {
      const selectedAccountInfo = this.activeAccounts.find(acc => acc.mt4Account === this.selectedAccount);
      if (!selectedAccountInfo) return;
      this.totalRewardAmount = selectedAccountInfo?.totalInterest;
      this.tradesAchieved = selectedAccountInfo?.tradesAchieved;
      this.progressData = [
        {
          rowTitle: this.$t('promotion.fundsGrowthPromotion.rewardSummary.eligibleReward'),
          totalRewardAmount: this.totalRewardAmount,
          ...selectedAccountInfo?.weeklyInterest.reduce((acc, { numOfWeek, interest }) => {
            acc[numOfWeek] = { amount: interest };
            return acc;
          }, {})
        }
      ];
    },
    async getFgpMonthlyHistory() {
      await apiGetFgpMonthlyHistory({ campaignId: this.campaignId }).then(resp => {
        if (resp.data.code === 0 && resp.data.data) {
          const isOptInAccounts = resp.data.data.participants.filter(x => x.isOptIn === true);
          if (isOptInAccounts.length > 0) {
            this.activeAccounts = isOptInAccounts;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/fundsGrowthPromotion/rewardSummary.scss';
ul,
li {
  list-style: inside;
}
</style>
